import BankingArticleDetailsV1Jsx from "./bankingArticleDetailsVersionOne";
import BankingArticleDetailsV2Jsx from "./bankingArticleDetailsVersionTwo";
import BankingArticleDetailsV3Jsx from "./bankingArticleDetailsVersionThree";
import BankingArticleDetailsV4Jsx from "./bankingArticleDetailsVersionFour";

const BankingArticleDetailsJsx = (props) => {
    
    const {
      detailsData
    } = props;

    const variants = {
        variant1:'variant1',
        variant2:'variant2',
        variant3:'variant3',
        variant4:'variant4',
    }
    return (
      <>


        {detailsData?.acf?.variant === variants.variant1 &&               
            <BankingArticleDetailsV1Jsx detailsData={detailsData} />                    
        }
        {detailsData?.acf?.variant === variants.variant2 &&
            <BankingArticleDetailsV2Jsx detailsData={detailsData} />        
        }
        {detailsData?.acf?.variant === variants.variant3 &&
            <BankingArticleDetailsV3Jsx detailsData={detailsData} />        
        }
        {detailsData?.acf?.variant === variants.variant4 &&
            <BankingArticleDetailsV4Jsx detailsData={detailsData} />        
        }
     
      </>

    )
}

export default BankingArticleDetailsJsx;